var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "loading-dialog",
        persistent: "",
        width: "440",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "loading-card", attrs: { color: "primary", dark: "" } },
        [
          _c("div", { staticClass: "loading-header" }, [
            _c(
              "svg",
              { staticClass: "spinner", attrs: { viewBox: "0 0 52 52" } },
              [
                _c("circle", {
                  staticClass: "spinner-track",
                  attrs: { cx: "26", cy: "26", r: "22" },
                }),
                _vm._v(" "),
                _c("circle", {
                  staticClass: "spinner-ring",
                  attrs: { cx: "26", cy: "26", r: "22" },
                }),
              ]
            ),
            _vm._v(" "),
            _c("h2", { staticClass: "loading-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("LoadingScreen.titleMsg")) +
                  "\n        "
              ),
              _c("span", { staticClass: "dot" }, [_vm._v(".")]),
              _c("span", { staticClass: "dot delay-1" }, [_vm._v(".")]),
              _c("span", { staticClass: "dot delay-2" }, [_vm._v(".")]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "loading-body" },
            _vm._l(_vm.progressMessages, function (message, index) {
              return _c(
                "div",
                { key: `step-${index}`, staticClass: "step" },
                [
                  index < _vm.progressMessages.length - 1
                    ? _c(
                        "v-icon",
                        { staticClass: "step-icon done", attrs: { small: "" } },
                        [_vm._v("mdi-check-circle")]
                      )
                    : _vm.progressMessages.length > 0 &&
                      index === _vm.progressMessages.length - 1 &&
                      message === "Done"
                    ? _c(
                        "v-icon",
                        { staticClass: "step-icon done", attrs: { small: "" } },
                        [_vm._v("mdi-check-circle")]
                      )
                    : _c(
                        "v-icon",
                        {
                          staticClass: "step-icon active",
                          attrs: { small: "" },
                        },
                        [_vm._v("mdi-loading")]
                      ),
                  _vm._v(" "),
                  _c("span", { staticClass: "step-label" }, [
                    _vm._v(_vm._s(message)),
                  ]),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "loading-status" }, [
            _c("span", { staticClass: "status-text" }, [
              _vm._v(_vm._s(_vm.currentStatus)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "status-percent" }, [
              _vm._v(_vm._s(Math.round(_vm.progressValue)) + "%"),
            ]),
          ]),
          _vm._v(" "),
          _c("v-progress-linear", {
            staticClass: "loading-progress",
            attrs: {
              color: "success",
              value: _vm.progressValue,
              height: "3",
              "background-opacity": "0.12",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }